import Vue from 'vue'

export const state = {
  trackedUnits: {},
  trackedUnitCount: 0
}

export const getters = {
  /**
   * Returns the full state object
   *
   * @param state Object
   *
   * @return Object
   */
  get (state) {
    return state
  },

  /**
   * Returns units that are being tracked.
   *
   * @param state Object
   *
   * @return Object
   */
  trackedUnits (state) {
    return state.trackedUnits
  },

  /**
   * Returns the number of units being tracked.
   *
   * @param state Object
   *
   * @return Integer
   */
  trackedUnitCount (state) {
    return state.trackedUnitCount
  }
}

export const actions = {
}

export const mutations = {
  /**
   * Add a map or array of object units that must be tracked.
   *
   * @param state Object
   * @param units Array|Map
   */
  addTrackedUnits (state, units) {
    units.forEach(unit => {
      Vue.set(state.trackedUnits, unit.id, unit)
    })

    state.trackedUnitCount = Object.keys(state.trackedUnits).length
  },

  /**
   * Removes an array of units that should no longer be tracked.
   * The array must consist of the id's of the units that no longer
   * requires tracking.
   *
   * @param state Object
   * @param units Array
   */
  removeTrackedUnits (state, units) {
    units.forEach(unitId => {
      Vue.delete(state.trackedUnits, unitId)
    })
    state.trackedUnitCount = Object.keys(state.trackedUnits).length
  },

  /**
   * Clears all units from being tracked.
   *
   * @param state Object
   */
  clearTrackedUnits (state) {
    state.trackedUnits = {}
    state.trackedUnitCount = 0
  },

  /**
   * Purge the module state
   *
   * @param state Object
   */
  purge (state) {
    state.trackedUnits = {}
    state.trackedUnitCount = 0
  },

  /**
   * Sets the telemetry data for the specified unit.
   *
   * @param state Object
   * @param unitId int
   * @param telemetry Object
   */
  setTelemetry (state, { unitId, telemetry }) {
    if (state.trackedUnits.hasOwnProperty(unitId)) {
      Vue.set(state.trackedUnits[unitId], 'telemetry', telemetry)
    }
  },

  /**
   * Sets the analog input configuration for the specified unit.
   *
   * @param state Object
   * @param unitId int
   * @param analogInputConfig Object
   */
  setAnalogInputCfg (state, { unitId, analogInputConfig }) {
    if (state.trackedUnits.hasOwnProperty(unitId)) {
      Vue.set(state.trackedUnits[unitId], 'an_inputs', analogInputConfig)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/units/trackedUnitsModule.js